module.exports = __webpack_public_path__ + "assets/wvhj-2026-badge.62b67fc1.png";